import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfiguracionEmailContactenosService } from './configuracion-email-contactenos.service';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';

@Component({
	selector: 'app-configuracion-email-contactenos',
	templateUrl: './configuracion-email-contactenos.component.html',
	styleUrls: ['./configuracion-email-contactenos.component.scss']
})
export class ConfiguracionEmailContactenosComponent implements OnInit {

	dataTabla: DatoPaginadoModel;
	headerEmailContactenos: Array<string>;
	formEmailContactenos: FormGroup;
	selectEmailContactenos: any;

	paginaActual: number;
	// filtros
	filtro: FormGroup;
	public isCollapsed = true;

	// Selects
	camaras: Array<any>;
	adminSuper = RolesUsuario.AdministradorSuper;
	camaraComercio: string;
	camarasLista: Array<CamaraComercioEntry>;

	constructor(private formBuilder: FormBuilder, private configuracionEmailContactenosService: ConfiguracionEmailContactenosService,
		private modalService: NgbModal, public authService: AuthService, private establecimientoComercioService: EstablecimientoComercioService) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;

		this.createForm();
		this.consultarListas();

		this.onConsultarEmailContactenos(1);

		this.selectEmailContactenos = null;
		this.paginaActual = 1;


	}

	ngOnInit() {
		this.headerEmailContactenos = ['Cámara de Comercio', 'Correo', 'Estado', 'Acción'];
		this.establecimientoComercioService.getCamaras().subscribe(resultado => {
			if (resultado) {
				this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
				if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
					this.formEmailContactenos.get('codigo_camara').patchValue(this.authService.getCamaraUser());
					this.camaraComercio = (this.camarasLista.find(x => x.codigo_camara ===
						this.authService.getCamaraUser()).desc_camara);
				}
			}
		});
	}

	createForm() {
		this.formEmailContactenos = this.formBuilder.group({
			codigo_camara: [null, Validators.required],
			correo_electronico: [null, Validators.required],
			desc_camara: [null],
			activo: [true],

		});

		this.filtro = this.formBuilder.group({
			codigo_camara: [null],
			desc_camara: [null],
			correo_electronico: [null],
			activo: [null],

		});
	}

	onConsultarEmailContactenos(page: number) {
		if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
			this.configuracionEmailContactenosService.get({
				...this.filtro.value, numeroPagina: page,
				codigo_camara: this.authService.getCamaraUser()
			})
				.subscribe(resultado => {
					if (resultado.result) {
						this.dataTabla = resultado.data as DatoPaginadoModel;
					}
				});
		} else {
			this.configuracionEmailContactenosService.get({ ...this.filtro.value, numeroPagina: page })
				.subscribe(resultado => {
					if (resultado.result) {
						this.dataTabla = resultado.data as DatoPaginadoModel;
					}
				});
		}

	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarEmailContactenos(value);
	}

	onAgregarEmailContactenos() {

		this.configuracionEmailContactenosService.create({
			...this.formEmailContactenos.value, activo: 1
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarEmailContactenos(this.paginaActual);
					this.formEmailContactenos.reset();
					if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
						this.formEmailContactenos.get('codigo_camara').patchValue(this.authService.getCamaraUser());
					}
				}
			});
	}

	onOperarEmailContactenos() {
		if (!this.selectEmailContactenos) {
			this.onAgregarEmailContactenos();
		} else {
			this.onModificarEmailContactenos();
		}
	}

	onCargarEmailContactenos(entry: any) {
		entry.activo = entry.activo ? 1 : 0;
		this.formEmailContactenos.patchValue({
			...entry,
		});
		this.selectEmailContactenos = entry;
		this.formEmailContactenos.get('activo').enable();
	}

	onEliminarEmailContactenos(entry: any) {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.configuracionEmailContactenosService.delete(entry).subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarEmailContactenos(this.paginaActual);
					this.selectEmailContactenos = null;
					this.formEmailContactenos.reset();
				}
			});
		});
	}

	onModificarEmailContactenos() {
		this.configuracionEmailContactenosService.update({
			...this.formEmailContactenos.value,
			configuracion_email_id: this.selectEmailContactenos.configuracion_email_id,
			codigo_camara: this.authService.getRolUser(RolesUsuario.AdministradorSuper) ?
				this.selectEmailContactenos.codigo_camara : this.authService.getCamaraUser()
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarEmailContactenos(this.paginaActual);
					this.formEmailContactenos.reset();
					this.formEmailContactenos.enable();
					this.formEmailContactenos.get('activo').disable();
					this.selectEmailContactenos = null;
					if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
						this.formEmailContactenos.get('codigo_camara').patchValue(this.authService.getCamaraUser());
					}
				}
			});
	}

	consultarListas() {
		// this.configuracionEmailContactenosService.getCamaras().subscribe(resultado => {
		// 	if (resultado.data) {
		// 		this.camaras = resultado.data;
		// 	}
		// });

		this.configuracionEmailContactenosService.getCamaras().subscribe(resultado => {
			if (resultado) {
				this.camaras = resultado.data as Array<CamaraComercioEntry>;
				if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
					this.formEmailContactenos.get('codigo_camara').patchValue(this.authService.getCamaraUser());
					this.formEmailContactenos.get('desc_camara').patchValue(this.camaras
						.find(x => x.codigo_camara === this.authService.getCamaraUser()).desc_camara);

					this.filtro.get('codigo_camara').patchValue(this.authService.getCamaraUser());
					this.filtro.get('desc_camara').patchValue(this.camaras
						.find(x => x.codigo_camara === this.authService.getCamaraUser()).desc_camara);
				}
			}
		});

	}

	filtrar() {
		this.paginaActual = 1;
		this.onConsultarEmailContactenos(1);
	}

	limpiar() {
		this.filtro.reset();
		this.filtrar();

	}
	limpiarCorreoContactenos() {
		this.formEmailContactenos.reset();
		this.selectEmailContactenos = null;
		this.createForm();
		if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
			this.formEmailContactenos.get('codigo_camara').patchValue(this.authService.getCamaraUser());
		}
	}
}
